import {Injectable} from '@angular/core';
import {GtmService} from './gtm.service';
import {SessionService} from './session.service';
import {ToolsService} from './tools.service';
import {DataLayerParamsClickGA4} from '../types/DataLayerParamsClickGA4';
import {GtmEventEnum} from '../enums/GoogleEnums';
import {DataLayerClickTag} from '../types/DataLayerClickTag';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GtmGa4EventPushService {
  constructor(
    private gtmService: GtmService,
    private session: SessionService,
    private tools: ToolsService,
    private router: Router,
  ) {}

  public pushClickEvent(eventParams: DataLayerParamsClickGA4): void {
    const url = this.router.url;

    const dlFields: string[] = [
      'callToAction',
      'bookingType',
      'inferredCareProviderTypeAreaId',
      'inferredCategoryTypeId',
      'mainCareProviderTypeId',
      'careServiceId',
      'careServiceTypeId',
      'symptomId',
      'cpruId',
      'treatmentId',
      'Timeslotnotexist',
      'pageType',
    ];

    dlFields.forEach((field) => {
      if (this.tools.isNil(eventParams[field])) {
        eventParams[field] = null;
      }
    });

    const gtmTag: DataLayerClickTag = {
      event: GtmEventEnum.CTA_CLICK,
      SessionID: this.session.getSessionID(),
      pageUrl: url,
      ...eventParams,
    };
    this.gtmService.pushTag(gtmTag);
  }
}
